import { Link } from 'react-router-dom';
import '../styles/About.css';
import bgImage from "../assets/bg.png";

export default function About() {
  return (
    <div className="about-root">

      {/* ── Background ── */}
      <div className="about-bg" style={{ backgroundImage: `url(${bgImage})` }} />

      {/* ── Top bar ── */}
      <nav className="about-topbar">
        <Link to="/" className="about-logo">D.Malipol</Link>
        <Link to="/" className="about-back">← Back to Home</Link>
      </nav>

      {/* ── Main content ── */}
      <div className="about-wrapper">

        {/* ── Left: Photo + quick stats ── */}
        <div className="about-left">
          <div className="about-avatar-wrap">
            <div className="about-avatar-ring" />
            <div className="about-avatar-inner">
              {<img src="/1000062748.jpeg" alt="Dylan Jeremy Malipol" />}
              <div className="about-avatar-fallback">AJ</div>
            </div>
          </div>

          <div className="about-quick-stats">
            <div className="stat-item">
              <span className="stat-value">3rd</span>
              <span className="stat-label">Year Student</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-value">CpE</span>
              <span className="stat-label">Major</span>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <span className="stat-value">PH</span>
              <span className="stat-label">Based</span>
            </div>
          </div>

          <div className="about-strengths">
            <p className="strengths-title">Personal Strengths</p>
            <div className="strength-tag">🧠 Problem Solver</div>
            <div className="strength-tag">📚 Fast Learner</div>
            <div className="strength-tag">💡 Creative Thinker</div>
          </div>
        </div>

        {/* ── Right: Text content ── */}
        <div className="about-right">

          <p className="about-section-label">◆ About Me</p>

          <h1 className="about-name">
            Hi, I'm Dylan<span className="accent"> Jeremy </span> Malipol
          </h1>
          <p className="about-role">Computer Engineering Student · Aspiring Software Developer</p>

          <div className="about-card">
            <p className="about-card-title">👋 Introduction</p>
            <p className="about-card-text">
              I'm a Computer Engineering student with a strong passion for technology, innovation, 
              and problem-solving. I turn ideas into functional, elegant software. With these 
              experience, it has allowed me to better understand how technology works and how 
              it is applied to solve real-world problems.
            </p>
          </div>

          <div className="about-card">
            <p className="about-card-title">🎓 Background as a Computer Engineering Student</p>
            <p className="about-card-text">
              As a Computer Engineering student, my background includes hands-on experience in 
              developing programs, working with circuit designs, and exploring embedded systems. 
              I have also been involved in academic projects that require critical thinking, 
              teamwork, and adaptability—skills that are essential in the field of engineering. 
              These experience have given me a strong technical foundation and a well-rounded 
              perspective on how modern computing systems are designed and built.
            </p>
          </div>

          <div className="about-card">
            <p className="about-card-title">💻 Why Computer Engineering?</p>
            <p className="about-card-text">
              I chose Computer Engineering because it started off with my grandma setting up 
              a shop, it involved computers, and I was fascinated by how computers work, 
              from the hardware and software. It gave me the opportunity to explore how they 
              work together to power the technology we use on our everyday lives.
            </p>
          </div>

          <div className="about-card">
            <p className="about-card-title">🚀 Career Goals & Aspirations</p>
            <p className="about-card-text">
              My goal is to become a well-rounded software engineer who can build impactful 
              products. In the near future, I aim to be a junior developer where I can improve 
              my skills in a collaborative environment. Long-term, I aspire to become the lead 
              in engineering teams and contribute to or build products that improve the lives of 
              the people through the use of this technology.
            </p>
          </div>

          <div className="about-cta">
            <Link to="/projects" className="btn btn-primary">🛠️ View My Projects</Link>
            <Link to="/contact"  className="btn btn-secondary">✉️ Get in Touch</Link>
          </div>

        </div>
      </div>
    </div>
  );
}